export const APP_PREFIX = "voyagePnl";

// Controls which rows are grey inside the PnL
export const excludedRows = ["Voyage days", "Port days", "Sea days", "Off hire days"];

export const revenueFields = [
  "Freight",
  "Demurrage",
  "Misc Revenue",
  "Despatch",
  "TCO Hire",
  "TCO Bunkers",
  "TCO Off hire",
];
export const expenseFields = ["Bunkers", "Port costs", "Misc Expenses", "Emissions", "Hire", "Off hire"];

export const revenueCategories: readonly string[] = [
  "Freight",
  "Demurrage",
  "Despatch",
  "Misc Revenue",
  "TCO Hire",
  "TCO Bunkers",
  "TCO Off hire",
];
export const expenseCategories: readonly string[] = ["Bunkers", "Port costs", "Misc Expenses", "Emissions"];
export const runningCostsCategories: readonly string[] = ["Hire", "Off hire"];

// Controls the formatting of rows that represent days inside the PnL
export const rowsWithDays = ["Voyage days", "Port days", "Sea days", "Off hire days"];
